import src from "IMAGE";
export default { src, width: 465, height: 141, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAIAAADq9gq6AAAALklEQVR42jXJoQEAMAgDQfaftpBAKhCNqTnxHyMVmIUvQO5uSBfsk8Uesl2txwN5Xi3nEfDiJQAAAABJRU5ErkJggg=="};
